const ContactRelationshipOptions = () => [
  { label: 'Orang Tua', value: 'Parent' },
  { label: 'Pasangan', value: 'Partner' },
  { label: 'Saudara', value: 'Sibling' },
  { label: 'Anak', value: 'Child' },
  { label: 'Lain-lain', value: 'Other' },
]

export default ContactRelationshipOptions